import AppLayout from '@components/layouts/appLayout';

import SurveyPageBody from './SurveyPageBody';
import SurveyPageFooter from './SurveyPageFooter';
import SurveyPageHeader from './SurveyPageHeader';
import { useSurveyContext } from '../contexts/SurveyContext';

const SurveyPage = () => {
    const { currentStep } = useSurveyContext();
    return (
        <AppLayout
            header={<SurveyPageHeader />}
            body={<SurveyPageBody />}
            footer={<SurveyPageFooter />}
            hasFixedFooter={true}
            footerHasPointerEvents={false}
            scrollToTopDependencies={[currentStep]}
        />
    );
};

export default SurveyPage;
